module.exports = __webpack_public_path__ + "static/media/international-exploratory-study-on-beauty-routines-for-women.d72891e8.jpg";